import clsx from 'clsx';

export function Card({ className, children, ...props }) {
  return (
    <div className={clsx('card-surface w-full', className)} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({ className, children, ...props }) {
  return (
    <div className={clsx('flex flex-col gap-1 border-b border-[rgba(var(--border),0.6)] px-6 py-5 dark:border-[rgba(var(--border),0.35)]', className)} {...props}>
      {children}
    </div>
  );
}

export function CardTitle({ className, children }) {
  return <h2 className={clsx('brand-heading text-lg', className)}>{children}</h2>;
}

export function CardDescription({ className, children }) {
  return (
    <p className={clsx('text-sm text-[rgb(var(--muted))] dark:text-slate-400', className)}>{children}</p>
  );
}

export function CardContent({ className, children, ...props }) {
  return (
    <div className={clsx('px-6 py-5', className)} {...props}>
      {children}
    </div>
  );
}

export default Card;
